import {
  NebulaFighterLightTheme,
  NebulaFighterTheme
} from './schemes/NebulaFighterTheme';

export function themeCreator(theme, direction = 'ltr') {
  const baseTheme = themeMap[theme];
  const isRTL = direction === 'rtl';

  // Merge the direction and RTL-specific component overrides
  return {
    ...baseTheme,
    direction: direction,
    components: {
      ...baseTheme.components,
      MuiListItemIcon: {
        ...baseTheme.components?.MuiListItemIcon,
        styleOverrides: {
          ...baseTheme.components?.MuiListItemIcon?.styleOverrides,
          root: {
            ...baseTheme.components?.MuiListItemIcon?.styleOverrides?.root,
            minWidth: isRTL ? 'auto' : 56,
            marginLeft: isRTL ? 16 : 0,
            marginRight: isRTL ? 0 : 16
          }
        }
      },
      MuiListItemText: {
        ...baseTheme.components?.MuiListItemText,
        styleOverrides: {
          ...baseTheme.components?.MuiListItemText?.styleOverrides,
          root: {
            ...baseTheme.components?.MuiListItemText?.styleOverrides?.root,
            marginLeft: isRTL ? 0 : 16,
            marginRight: isRTL ? 16 : 0
          }
        }
      },
      MuiListItemButton: {
        ...baseTheme.components?.MuiListItemButton,
        styleOverrides: {
          ...baseTheme.components?.MuiListItemButton?.styleOverrides,
          root: {
            ...baseTheme.components?.MuiListItemButton?.styleOverrides?.root,
            paddingLeft: isRTL ? 16 : 24,
            paddingRight: isRTL ? 24 : 16
          }
        }
      },
      MuiButton: {
        ...baseTheme.components?.MuiButton,
        styleOverrides: {
          ...baseTheme.components?.MuiButton?.styleOverrides,
          startIcon: {
            ...baseTheme.components?.MuiButton?.styleOverrides?.startIcon,
            marginLeft: isRTL ? 8 : -4,
            marginRight: isRTL ? -4 : 8
          },
          endIcon: {
            ...baseTheme.components?.MuiButton?.styleOverrides?.endIcon,
            marginRight: isRTL ? 8 : -4,
            marginLeft: isRTL ? -4 : 8
          }
        }
      }
    }
  };
}

const themeMap = {
  NebulaFighterTheme,
  NebulaFighterLightTheme
};
